/* eslint-disable @typescript-eslint/no-explicit-any */
import InputLabel from "@material-ui/core/InputLabel";

import PermIdentity from "@material-ui/icons/PermIdentity";

import Card from "components/UI/Card/Card.js";
import CardBody from "components/UI/Card/CardBody.js";
import CardHeader from "components/UI/Card/CardHeader.js";
import CardIcon from "components/UI/Card/CardIcon.js";
import CustomInput from "components/Forms/CustomInput/CustomInput.js";

import { Box, Grid } from "@material-ui/core";
import { useUserInfo } from "store/auth/auth-store";

interface User {
  name: string;
  email: string;
  realm_access: {
    roles: string[];
  };
}
export default function UserProfile() {
  const { userInfo } = useUserInfo();

  const userDataInfo: User = userInfo;

  return (
    <Box>
      <Grid container>
        <Grid xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <PermIdentity />
              </CardIcon>
            </CardHeader>
            <CardBody>
              <Grid>
                <Grid xs={12} sm={12} md={5}>
                  <InputLabel>Username</InputLabel>
                  <CustomInput
                    id="name-disabled"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: userDataInfo?.name,
                    }}
                  />
                </Grid>
                <Grid xs={12} sm={12} md={7}>
                  <InputLabel>E-mail</InputLabel>
                  <CustomInput
                    id="email-address"
                    inputProps={{
                      disabled: true,
                      value: userDataInfo?.email,
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid>
                <Grid xs={12} sm={12} md={12}>
                  <InputLabel>Roles</InputLabel>
                  <CustomInput
                    id="about-me"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      multiline: true,
                      disabled: true,
                      value:
                        userDataInfo?.realm_access?.roles &&
                        userDataInfo?.realm_access?.roles
                          .map((role: string) => role.toUpperCase())
                          .filter((role: string) => role)
                          .join("\n"),
                    }}
                  />
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
